import { baseService } from "./base";

export const playerVersionsService = {
  load() {
    return baseService.get(`/api/player-versions`);
  },
};

export default playerVersionsService;
